"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("@atlaskit/theme");
const colors = __importStar(require("@atlaskit/theme/colors"));
const boxShadow = "0 3px 0 0 rgba(0, 0, 0, 0.05), 0 0 0 2px rgba(0, 0, 0, 0.03)";
exports.Card = styled_components_1.default.div `
  position: relative;
  padding: 10px;
  margin: 10px;
  border-radius: 2px;
  background-color: ${theme_1.themed({ light: colors.N0, dark: colors.DN50 })};
  box-shadow: ${boxShadow};
`;
